<script>
    import { Router } from "@roxi/routify";
    import { routes } from "../.routify/routes";
    import './assets/FenomenSans/FenomenSans.css'
    import './assets/FenomenSans-Bold/FenomenSans.css'
    import './assets/FenomenSans-SemiBold/FenomenSans.css'
    import './assets/FenomenSans-Italic/FenomenSans.css'
    import './assets/FenomenSans-BoldItalic/FenomenSans.css'
    import * as Sentry from "@sentry/svelte";

    const base = import.meta.env.BASE_URL.replace(/\/$/, '')  // strip trailing slash

    const config = {
        urlTransform: {
            apply: url => url.startsWith('/') ? `${base}${url}` : `${base}/${url}`,
            remove: url => url.replace(base, ''),
        },
        useHash: false
    }

    Sentry.init({
        /*dsn: "https://377e7f461df2985d9eee56a636c638b3@o4508447667978240.ingest.de.sentry.io/4508635299184720",
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],*/
        dsn: "https://4ab53bf7452ce71ff6a5e9371fea515d@sentry.upce.cz/4",
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({
                maskAllText: false,        // Zkontroluj, jestli nemaskuješ vstupy
                blockAllMedia: false,      // Možná blokuješ media elements
            }),
        ],
        // Tracing
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: [/^https:\/\/akreditace\.upce\.cz/],
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.

    });

</script>


<Router {routes} {config}/>